import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash';
import PaymentStatusStore from '../../../stores/PaymentStatusStore';
import config from '../../../config';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { renderAccountDetails } from '../ViewPaymentHistory';

import PrintHelper from 'print-helper-lib';
import StatusBadgeSME from './StatusBadgeSME';

import ViewChildPaymentHistory from './ViewChildPaymentHistory';
import envConfig from '../../../../static/config';

// Conditional columns, based on payment details
export const getColumns = (paymentHistoryDetails, content) => {
  const {
    createdBy,
    createdDate,
    authorisedBy,
    reference,
    bacsId,
    settlement_date,
  } = paymentHistoryDetails;

  const columns = [
    ...(createdDate
      ? [
          {
            title: [content.createdOnLabel],
            id: 'createdDate',
            path: ['createdDate'],
          },
        ]
      : []),
    ...(createdBy
      ? [
          {
            title: [content.createdByLabel],
            id: 'createdBy',
            path: ['createdBy'],
          },
        ]
      : []),
    {
      title: [content.fromLabel],
      id: 'fromAccount',
      path: ['fromAccount'],
    },
    {
      title: [content.toLabel],
      id: 'toAccount',
      path: ['toAccount'],
    },
    {
      title: [content.amount],
      id: 'amountRaw',
      path: ['amount'],
    },
    {
      title: [content.paymentType],
      id: 'paymentType',
      path: ['paymentType'],
    },
    ...(bacsId
      ? [
          {
            title: [content.bacsID],
            id: 'bacsId',
            path: ['bacsId'],
          },
        ]
      : []),

    ...(reference
      ? [
          {
            title: [content.referenceLabel],
            id: 'reference',
            path: ['reference'],
          },
        ]
      : []),
    ...(authorisedBy
      ? [
          {
            title: [content.authorisedByLabel],
            id: 'authorisedBy',
            path: ['authorisedBy'],
          },
        ]
      : []),
    ...(settlement_date
      ? [
          {
            title: [content.settlementPaymentDateLabel],
            id: 'settlementDate',
            path: ['settlementDate'],
          },
        ]
      : []),
    {
      title: [content.status],
      id: 'status',
      path: ['statusBadge'],
    },
  ];

  return columns;
};

export const getFormattedData = (paymentHistoryDetails) => {
  const {
    status,
    fromAccountName,
    fromAccountAccountNumber,
    fromAccountSortCode,
    toAccountAccountNumber,
    toAccountSortCode,
    toAccountName,
    settlement_date,
  } = paymentHistoryDetails;

  return [
    {
      ...paymentHistoryDetails,
      statusBadge: <StatusBadgeSME status={status} />,
      statusMsg: PaymentStatusStore.getMessageByStatusCode(
        get(paymentHistoryDetails, 'statusCode')
      ),
      fromAccount: (
        <Identifier.Breaking>
          {renderAccountDetails(
            fromAccountAccountNumber,
            fromAccountSortCode,
            fromAccountName
          )}
        </Identifier.Breaking>
      ),
      toAccount: (
        <Identifier.Breaking>
          {renderAccountDetails(
            toAccountAccountNumber,
            toAccountSortCode,
            toAccountName
          )}
        </Identifier.Breaking>
      ),
      settlementDate: moment(settlement_date).format(config.dateFormatTimeline),
    },
  ];
};

class ViewBatchPaymentHistory extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    const { paymentHistoryDetails, goBack, content = {} } = this.props;

    const columns = getColumns(paymentHistoryDetails, content);
    const data = getFormattedData(paymentHistoryDetails);

    return (
      <div className="web-ui-components payment-history-batch">
        <div className="u-component-spacing">
          <BackButton onClick={goBack} />

          <SectionHeading>Payment Summary</SectionHeading>
          <div className="u-margin-bottom-4">
            <PrintHelper
              className="web-ui-components"
              brandId={envConfig.brandId}
              showPrintTopIcon
              showPrintBottomIcon={false}
            />

            <DataTable
              layout="transactions"
              columns={columns}
              data={data}
              isBranded
              keyPath={['id']}
            />
          </div>
          <div className="u-margin-bottom-2">
            <ViewChildPaymentHistory
              historyDetails={paymentHistoryDetails}
              content={content}
            />
          </div>
          <div className="noprint">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}

ViewBatchPaymentHistory.propTypes = {
  paymentHistoryDetails: PropTypes.object,
  goBack: PropTypes.func,
  content: PropTypes.object,
};

export default ViewBatchPaymentHistory;
